module.exports = __webpack_public_path__ + "static/cba-grey-9520839175289546a76fa44bfcaf121e.png";